import { lazy } from "react";

const PagesRoutes = [
  {
    path: "/pages/blank-page",
    component: lazy(() => import("../../view/pages/blank")),
    layout: "VerticalLayout",
  },
  {
    path: "/pages/error-page",
    component: lazy(() => import("../../view/pages/error")),
    layout: "FullLayout",
  },
  {
    path: "/login",
    component: lazy(() => import("../../view/Login")),
    layout: "FullLayout",
  },
  {
    path: "/forgotpassword",
    component: lazy(() => import("../../view/Login/Password/ForgotPassword")),
    layout: "FullLayout",
  },
  {
    path: "/resetpassword",
    component: lazy(() => import("../../view/Login/Password/ResetPassword")),
    layout: "FullLayout",
  },
  {
    path: "/dashboard",
    component: lazy(() => import("../../view/Dashboard")),
    layout: "VerticalLayout",
  },
  {
    path: "/tasklist",
    component: lazy(() => import("../../view/TaskList")),
    layout: "VerticalLayout",
  },
  {
    path: "/expenseclaim",
    component: lazy(() => import("../../view/ExpenseClaim")),
    layout: "VerticalLayout",
  },
  {
    path: "/newexpense",
    component: lazy(() => import("../../view/NewExpense")),
    layout: "VerticalLayout",
  },
  {
    path: "/employeeadvance",
    component: lazy(() => import("../../view/EmployeeAdvance")),
    layout: "VerticalLayout",
  },
  {
    path: "/salesquotation",
    component: lazy(() => import("../../view/SalesQuotationList")),
    layout: "VerticalLayout",
  },
  {
    path: "/newsalesquotation",
    component: lazy(() => import("../../view/NewSalesQuotation")),
    layout: "VerticalLayout",
  },
  {
    path: "/salesorder",
    component: lazy(() => import("../../view/SalesOrderList")),
    layout: "VerticalLayout",
  },
  {
    path: "/newsalesorder",
    component: lazy(() => import("../../view/NewSalesOrder")),
    layout: "VerticalLayout",
  },
  {
    path: "/purchaseorder",
    component: lazy(() => import("../../view/PurchaseOrderList")),
    layout: "VerticalLayout",
  },
  {
    path: "/newpurchaseorder",
    component: lazy(() => import("../../view/NewPurchaseOrder")),
    layout: "VerticalLayout",
  },
  {
    path: "/flexiquote",
    component: lazy(() => import("../../view/FlexiQuote")),
    layout: "VerticalLayout",
  },
  {
    path: "/newflexiquote",
    component: lazy(() => import("../../view/NewFlexiQuote")),
    layout: "VerticalLayout",
  },
  {
    path: "/invoicerequest",
    component: lazy(() => import("../../view/InvoiceRequestList")),
    layout: "VerticalLayout",
  },
  {
    path: "/newinvoicerequest",
    component: lazy(() => import("../../view/NewInvoiceRequest")),
    layout: "VerticalLayout",
  },
  {
    path: "/opportunity",
    component: lazy(() => import("../../view/OpportunityList")),
    layout: "VerticalLayout",
  },
  {
    path: "/newopportunity",
    component: lazy(() => import("../../view/NewOpportunity")),
    layout: "VerticalLayout",
  },
  {
    path: "/timesheet",
    component: lazy(() => import("../../view/TimeSheet")),
    layout: "VerticalLayout",
  },
  {
    path: "/timeSheetList",
    component: lazy(() => import("../../view/TimeSheetMain")),
    layout: "VerticalLayout",
  },
  {
    path: "/approvals",
    component: lazy(() => import("../../view/Approvals")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings",
    component: lazy(() => import("../../view/Settings")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/skills",
    component: lazy(() => import("../../view/Settings/TeamSync/Skills")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/organization-level",
    component: lazy(() => import("../../view/Settings/TeamSync/OrganizationLevel")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/user-department",
    component: lazy(() => import("../../view/Settings/TeamSync/UserDepartment")),
    layout: "VerticalLayout",
  },
  {
    path: "/emailcredential",
    component: lazy(() => import("../../view/EmailCredentials")),
    layout: "VerticalLayout",
  },
  {
    path: "/emailcontent",
    component: lazy(() => import("../../view/EmailContent")),
    layout: "VerticalLayout",
  },
  {
    path: "/sms",
    component: lazy(() => import("../../view/SMS")),
    layout: "VerticalLayout",
  },
  {
    path: "/smscreatepattern",
    component: lazy(() => import("../../view/SMSCreatePattern")),
    layout: "VerticalLayout",
  },
  {
    path: "/smsviewpatterns",
    component: lazy(() => import("../../view/SMSViewPatterns")),
    layout: "VerticalLayout",
  },
  {
    path: "/failedapprovals",
    component: lazy(() => import("../../view/FailedApprovals")),
    layout: "VerticalLayout",
  },
  {
    path: "/reportlist",
    component: lazy(() => import("../../view/ReportsList")),
    layout: "VerticalLayout",
  },
  {
    path: "/report",
    component: lazy(() => import("../../view/Report")),
    layout: "VerticalLayout",
  },
  {
    path: "/kit",
    component: lazy(() => import("../../view/Kit")),
    layout: "VerticalLayout",
  },
  {
    path: "/NewKit",
    component: lazy(() => import("../../view/NewKit")),
    layout: "VerticalLayout",
  },
  {
    path: "/apms-dashboard",
    component: lazy(() => import("../../view/APMS/Dashboard")),
    layout: "VerticalLayout",
  },
  {
    path: "/Projects",
    component: lazy(() => import("../../view/APMS/Projects")),
    layout: "VerticalLayout",
  },
  {
    path: "/ProjectsDetails",
    component: lazy(() => import("../../view/APMS/ProjectsDetails")),
    layout: "VerticalLayout",
  },
  {
    path: "/sub-projects",
    component: lazy(() => import("../../view/APMS/SubProjects")),
    layout: "VerticalLayout",
  },
  {
    path: "/Tickets",
    component: lazy(() => import("../../view/APMS/Tickets")),
    layout: "VerticalLayout",
  },
  {
    path: "/TicketReview",
    component: lazy(() => import("../../view/APMS/AgedTicketsReview")),
    layout: "VerticalLayout",
  },
  {
    path: "/TicketsDetails",
    component: lazy(() => import("../../view/APMS/TicketsDetails")),
    layout: "VerticalLayout",
  },
  {
    path: "/LogWork",
    component: lazy(() => import("../../view/APMS/LogWork")),
    layout: "VerticalLayout",
  },
  {
    path: "/Customers",
    component: lazy(() => import("../../view/APMS/Customers")),
    layout: "VerticalLayout",
  },
  {
    path: "/CustomersDetails",
    component: lazy(() => import("../../view/APMS/CustomersDetails")),
    layout: "VerticalLayout",
  },
  {
    path: "/taskPlanner",
    component: lazy(() => import("../../view/TaskPlanner")),
    layout: "VerticalLayout",
  },
  {
    path: "/projectCalendar",
    component: lazy(() => import("../../view/TaskPlanner/ProjectCalendar")),
    layout: "VerticalLayout",
  },
  {
    path: "/predefinedGoals",
    component: lazy(() => import("../../view/TaskPlanner/Goals/PredefinedGoals")),
    layout: "VerticalLayout",
  },
  {
    path: "/clusterAnalysis",
    component: lazy(() => import("../../view/TaskPlanner/Cluster/ClusterAnalysis")),
    layout: "VerticalLayout",
  },
  {
    path: "/allsettings",
    component: lazy(() => import("../../view/Settings/AllSettings")),
    layout: "VerticalLayout",
  },
  {
    path: "/trips",
    component: lazy(() => import("../../view/Trips")),
    layout: "VerticalLayout",
  },
  {
    path: "/NewTrips",
    component: lazy(() => import("../../view/NewTrips")),
    layout: "VerticalLayout",
  },
  {
    path: "/TripsDetails",
    component: lazy(() => import("../../view/TripsDetails")),
    layout: "VerticalLayout",
  },
  {
    path: "/MyProfile",
    component: lazy(() => import("../../view/UserMaster")),
    layout: "VerticalLayout",
  },
  {
    path: "/powerbi",
    component: lazy(() => import("../../view/PowerBi")),
    layout: "VerticalLayout",
  },
  {
    path: "/payrollreport",
    component: lazy(() => import("../../view/PayrollReport")),
    layout: "VerticalLayout",
  },
  {
    path: "/invoiceengine",
    component: lazy(() => import("../../view/InvoiceEngine")),
    layout: "VerticalLayout",
  },
  {
    path: "/newinvoice",
    component: lazy(() => import("../../view/NewInvoice")),
    layout: "VerticalLayout",
  },
  {
    path: "/demand-list",
    component: lazy(() => import("../../view/demandManagement")),
    layout: "VerticalLayout",
  },
  {
    path: "/demand-details/:demandId",
    component: lazy(() => import("../../view/demandManagement/DemandDetails")),
    layout: "VerticalLayout",
  },
  {
    path: "/demand-casestudy",
    component: lazy(() => import("../../view/demandManagement/CaseStudies")),
    layout: "VerticalLayout",
  },
  {
    path: "/demand-invoice-request",
    component: lazy(() => import("../../view/demandManagement/invoiceRequest")),
    layout: "VerticalLayout",
  },
  {
    path: "/custom-reports",
    component: lazy(() => import("../../view/custom-reports")),
    layout: "VerticalLayout",
  },
  {
    path: "/schedule-reports",
    component: lazy(() => import("../../view/schedule-reports")),
    layout: "VerticalLayout",
  },
];

export default PagesRoutes;